<div class="wrapper">
  <app-mgvw-records-list />
</div>
